/**
 * Menu items hook
 * Thin wrapper around data layer using React Query
 */

import { useQuery } from "@tanstack/react-query";
import { menuKeys, queryOptions } from "@/data/query-keys";
import { getMenuItems } from "@/data/supabase/menu";
import { getCurrentUserCompanyId } from "@/lib/userUtils";

// Re-export types for backward compatibility
export type { MenuItem, MenuItemCOGS } from "@/data/supabase/menu";

export const useMenuItems = () => {
  return useQuery({
    queryKey: menuKeys.items(),
    queryFn: async () => {
      const companyId = await getCurrentUserCompanyId();
      if (!companyId) return [];
      return getMenuItems(companyId);
    },
    staleTime: queryOptions.menu.staleTime,
    gcTime: queryOptions.menu.gcTime,
  });
};
